import { z } from "zod";

import { constantsData } from "@/data";

export const verifyAccountFormSchema = z.
    object({
        confirmPassword: z.
            string().
            min(6).
            max(30).
            nonempty({ message: constantsData.msgs.requiredField }),

        email: z.string().min(
            1,
            { message: constantsData.msgs.requiredField },
        ).email(constantsData.msgs.notValidEmail),
        fullName: z.string().min(
            1,
            { message: constantsData.msgs.requiredField },
        ),
        password: z.
            string().
            min(6).
            max(30).
            nonempty({ message: constantsData.msgs.requiredField }),
    }).
    refine(
        (data) => data.password === data.confirmPassword,
        {
            message: constantsData.msgs.passwordsDoNotMatch,
            path: ["confirmPassword"],
        },
    );
